import React from "react";

function NotFound() {
  return (
    <div
      style={{ fontSize: "8rem", height: "100vh" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <div>
        <h1 className="d-flex justify-content-center">404</h1>
        <h2 className="d-flex justify-content-center">Not Found</h2>
        <h6 className="d-flex justify-content-center text-dark text-center">
          The resource requested could not be found on this server.
        </h6>
        <hr />
      </div>
      <div className="fs-5 d-flex flex-column align-items-center justify-content-center navbar-brand mb-5">
        <span className="logo_diferent  fs-5 text-dark pb-1">The </span>
        <span className="logo  fs-5  pb-1">Wine </span>
        <span className="logo_diferent  fs-5 text-dark pb-1">Cabinet</span>
      </div>
    </div>
  );
}

export default NotFound;
